var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"lang-select",attrs:{"prepend-inner-icon":"mdi-web","items":_vm.langs,"color":"primary-1","solo":""},on:{"change":_vm.setLang},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})
}
var staticRenderFns = []

export { render, staticRenderFns }